import { IFieldsData } from '@checkout/state';
import { FormikProps, connect } from 'formik';
import { debounce } from 'lodash';
import * as React from 'react';

const isEqual = require('react-fast-compare');

export interface IPersistProps {
  debounce?: number;
  formikContext: FormikProps<IFieldsData>;
  handlePersist: (value: any) => void;
  fieldsDataValues: IFieldsData;
}

type Props = IPersistProps & { formik: FormikProps<any> };

class FormikPersist extends React.Component<Props, {}> {
  static defaultProps = {
    debounce: 700,
  };

  saveForm = debounce((formik: FormikProps<IFieldsData>) => {
    this.props.handlePersist(formik.values);
  }, this.props.debounce);

  componentDidUpdate(prevProps: IPersistProps & { formik: FormikProps<IFieldsData> }) {
    const { formikContext } = this.props;

    if (!isEqual(prevProps.formik.values, formikContext.values)) {
      this.saveForm(formikContext);
    }
  }

  componentDidMount() {
    const { formikContext, fieldsDataValues } = this.props;

    formikContext.setValues(fieldsDataValues);
  }

  componentWillUpdate(nextProps: Props) {
    const { formikContext } = this.props;
    if (!isEqual(this.props.fieldsDataValues, nextProps.fieldsDataValues)) {
      formikContext.setValues(nextProps.fieldsDataValues);
    }
  }

  render() {
    return null;
  }
}

export default connect<IPersistProps, any>(FormikPersist);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/FormikPersist/FormikPersist.tsx